
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,
};
